import styled from "styled-components";
import {
  accent,
  primary,
  secondary,
  symbol,
  white,
  gray,
} from "~/components/mixins/color";

export const Container = styled.div`
  height: calc(100% - 20px);
  margin: 10px;
  display: grid;
  background: ${white.hex()};
  border-radius: 6px;
  overflow: hidden;
`;

export const Row = styled.div`
  display: grid;
  grid-column-gap: 10px;
  grid-template-columns: repeat(${(props) => props.span || 1}, 1fr);
  width: 100%;
`;

export const SearchContainer = styled.div`
  display: flex;
  padding: 5px 10px;
  background: ${white.hex()};
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  background: ${white.hex()};
  align-items: center;
  border-radius: 6px;

  & > img {
    width: 120px;
    margin: 10px;
  }
`;

export const HeaderData = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  justify-content: center;
  width: 100%;
`;

export const FormData = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  .left {
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    background: ${white.hex()};
  }

  .right {
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    padding-left: 18px;
    background: ${white.hex()};
    border-left: 1px solid ${primary.hex()};
    width: 100%;

    & > div.access {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      > .accessData {
        width: 100%;
        margin-right: 10px;
      }

      > .avatar {
        padding: 8px;
        border: 1px solid #eee;
        border-radius: 6px;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 170px;

        & > img {
          object-fit: cover;
          max-width: 152px;
          max-height: 152px;
          border-radius: 6px;
        }
      }
    }
  }
`;

export const ReplaceContainer = styled.div`
  display: flex;
  padding: 10px;
  background: ${white.hex()};
  border-radius: 6px;
  justify-content: center;
  align-items: center;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  padding: 8px;
  background: ${secondary.hex()};
  justify-content: flex-end;
  align-items: center;
  border-radius: 2px;
`;

export const ImageButton = styled.button`
  display: grid;
  place-items: center;
  padding: 10px;
  width: ${(props) => props.width || 100}px;
  height: ${(props) => props.height || 100}px;
  border: 1px solid ${accent.fade(0.8).string()};
  border-radius: 2px;
  color: ${accent.hex()};
  margin-right: 5px;
  background: ${white.hex()};

  &:disabled {
    border: 1px solid ${symbol.fade(0.8).string()};
    color: ${symbol.fade(0.8).string()};
    cursor: crosshair;
  }

  &:hover:enabled {
    background: ${accent.hex()};
    color: ${white.hex()};
  }

  & > svg {
    width: ${(props) => props.height * 0.25 || 35}px;
    height: ${(props) => props.height * 0.25 || 35}px;
  }

  span {
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.8rem;
  }
`;

export const CheckArea = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  height: 100px;
  font-size: 2.2rem;
  color: ${symbol.hex()};
  justify-content: space-around;
  border-radius: 4px;
  border: 1px solid ${primary.hex()};

  & > span {
    font-size: 1rem;
    margin-bottom: 8px;
  }

  & > strong {
    font-weight: 500;
  }
`;

export const InputItem = styled.div`
  display: grid;
  position: relative;
  margin: 0 0 10px;
  width: 100%;

  & > svg {
    position: absolute;
    right: 15px;
    align-self: center;
    color: ${gray.hex()};
    transition: color 0.2s ease 0s;
  }
  
  & > svg:hover {
    color: ${accent.hex()};
    cursor: pointer;
  }

  &:focus-within > input {
    border-color: ${accent.hex()};
  }

  &:focus-within > svg {
    color: ${accent.hex()};
  }

  input {
    background: ${secondary.hex()};
    border: 2px solid ${secondary.hex()};
    border-radius: 3px;
    padding: 19px 40px 8px 10px;
    color: ${gray.hex()};
    position: relative;
    transition: border-color 0.2s ease-in 0s;

    &:disabled {
      opacity: 0.75;
    }

    &::placeholder {
      color: transparent;
    }

    &:focus + label,
    &:not(:placeholder-shown) + label{
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
    }

    &:not(:focus):not(:invalid):not(:placeholder-shown) + label {
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
    }

    & + label {
      position: absolute;
      top: 15px;
      padding-left: 10px;
      transition: all 200ms;
      opacity: 0.75;
      color: ${gray.hex()};
    }
  }
`;